import { useMutation } from '@tanstack/react-query';
import { showResult } from 'infrastructure/hooks/utils';
import dataService from 'services/dataService';

import type { IStopSlaTimerResponse } from 'infrastructure/interfaces/i-rpm-patient-activity';

interface DataProps {
  readingIds: {
    readingId: string;
    deviceId: string;
  }[];
  callId: string;
  patientGuid: string;
}

const getUrl = (patientGuid: string) =>
  `core-2/patients/${patientGuid}/readings/link-call`;

const mutationFn = async ({ patientGuid, ...postData }: DataProps) => {
  const url = getUrl(patientGuid);
  const { error, data } = await dataService.createOne<IStopSlaTimerResponse>(
    url,
    postData,
  );
  if (error) {
    showResult(error);
  }

  return data;
};

export const useLinkReadingsToCall = () => {
  const { mutate, isLoading } = useMutation({
    mutationFn,
  });

  return {
    linkReadingsToCall: mutate,
    isLoading,
  };
};
